import React from 'react'
import styled from 'styled-components'
import { WithAuth as Root } from '@/components/Root'
import { UsersTable } from '@/components/tables/UsersTable'
import { Layout, PageHeader } from 'antd'

const pageTitle = '登録ユーザー'

export default () => (
  <Root title={pageTitle}>
    <Layout>
      <StyledPageHeader title={pageTitle} />
      <UsersTable />
    </Layout>
  </Root>
)

const StyledPageHeader = styled(PageHeader)`
  margin: 16px 0;
  background-color: #fff;
`
